import type * as api from '@gitbook/api-client';
import type { NavigationShareSideSheet } from '@gitbook/app-navigation';
import { DialogRoot } from '@gitbook/spine-react';

import { PublishSpaceDialog } from '../../../Components';
import { useSideSheetNavigation } from '../../../navigation';
import { useToggleShareModal } from './SpaceShareDialog';

function usePublishModalState() {
    const state = useSideSheetNavigation<NavigationShareSideSheet>('share');
    const setOpen = useToggleShareModal('docs-sites');
    return [state.selectedTab === 'docs-sites' && state.opened, setOpen] as const;
}

/**
 * Button to open the publish modal for a space.
 */
export function SpacePublishDialog(props: { space: api.Space }) {
    const { space } = props;
    const [opened, setOpen] = usePublishModalState();

    return (
        <DialogRoot isOpen={opened} onOpenChange={setOpen} key={space.id}>
            <PublishSpaceDialog content={{ space }} />
        </DialogRoot>
    );
}
